<template>
    <v-dialog v-model="modalvideo" :transition="fullscreen?'dialog-bottom-transition':'dialog-transition'" persistent :fullscreen="fullscreen" :width="width" scrollable>
        <v-card class="fondo-curso-modal">
            <v-toolbar class="cerrar" :style="{'background':backColorCerrar , 'height':heightCerrar }">
                <slot name="modaltittle"></slot>
                <!-- <v-spacer> </v-spacer> -->
                <button v-if="mostrarCerrar" @click="$emit('click', false)" class="hvr hvr-scale"><img src="@/assets/imagenes_compartidas/Cerrar_Ventana.png" alt="botón cerrar"></button>
            </v-toolbar>
            <v-card-text class="cont-content">
                <v-flex contain class="dialog-content" text-xs-center>
                    <slot></slot>
                </v-flex>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        model: {
            prop: 'modalvideo',
            event: 'click'
        },
        props: {
            modalvideo: Boolean,
            width: {
                type: String,
                default: '700px'
            },
            fullscreen: {
                type: Boolean,
                default: true,
            },
            mostrarCerrar: {
                type: Boolean,
                default: true
            },
            backColorCerrar:{
                type:String,
                default:'rgba($color: #000000, $alpha: .9)'
            },
            heightCerrar:{
                type:String,
                default:'45px'
            }

        },
        data() {
            return {
            }
        },
        watch: {
            fullscreen: function(value){
                if(value){

                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../sass/helpers/variables';
    .cerrar {
        padding-bottom: 0;
        height: 45px;
        text-align: center;
        box-shadow: none;
        background: rgba($color: #000000, $alpha: 0);
        img{
            width: 30px;
            height: 30px;
        }
    }

    .dialog-content {
        max-width: 100%;
        margin: auto;
        padding: 5px;
        align-items: center;
        font-size: 0.8em;
        display: flex;
        justify-content: center;
        align-items: center;
        // @media (max-height: 800px){
        //     align-items: start;
        // }
    }

    .fullscreen {
        @media (min-height: 800px){
            height: 70vh;
        }
    }
    .fondo-curso-modal{
        background: rgba($color: #000000, $alpha: .9);
    }
    .cont-content{
        display: flex;
        height: 100%;
    }
</style>
